import Feedable from '@/global/dejaVue/feedable'
import ROUTE from '@/router/routeEnum'

export default class MenuItem extends Feedable {
    public route = ROUTE.HOME
    public icon = ''
    public text = ''

    constructor(options?: any) {
        super(options)
        this.feed(options)
    }

    public feed(options?: any) {
        if (options?.route) this.route = options.route
        if (options?.icon) this.icon = options.icon
        if (options?.text) this.text = options.text
        return this
    }

    public static make(route: ROUTE, icon: string, text: string) {
        return new MenuItem({ route: route, icon: icon, text: text })
    }
}
